import immigrantContractAbi from "../json/ImmigrantContractABI.json";

export const IMMIGRANT_CONTRACT = '0x5583651fD633cEd5439F923bc0510Ea1A121542C';
export const IMMIGRANT_CONTRACT_ABI = immigrantContractAbi.abi;